
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/qualification-check",
      function () {
        return require("private-next-pages/bcks/qualification-check.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/qualification-check"])
      });
    }
  